import "./AlumniRollCall.module.css";
import Header from "@/reusable_sections/Header";
import WhoSComing from "./sections/WhoSComing";
import MissingClassmates from "./sections/MissingClassmates";
import Footer from "@/reusable_sections/Footer";
export default function AlumniRollCallPage() {
  return <div>
      <Header />
      <WhoSComing />
      <MissingClassmates />
      <Footer />
    </div>;
}